import React, { useEffect, useRef, useState } from "react";

interface BackgroundProps extends React.SVGProps<SVGSVGElement> {
    progress: number; // value between 0 and 1
}

const Background: React.FC<BackgroundProps> = ({ progress, ...props }) => {
    const pathRef = useRef<SVGPathElement>(null);
    const [pathLength, setPathLength] = useState(0);

    useEffect(() => {
        if (pathRef.current) {
            const length = pathRef.current.getTotalLength();
            setPathLength(length);
        }
    }, []);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1346.6 585.8"
            {...props}
        >
            {/* Hintergrundfläche */}
            <path
                d="M1055.98,557.68c146.51,0,265.7-119.01,265.7-265.3S1202.54,27.12,1056.13,27.09
                  l-765.52,1.03C144.11,28.12,24.92,147.13,24.92,293.41s119.13,265.25,265.55,265.3h.03l765.49-1.02h0Z"
                fill="var(--inner-bg)"
                style={{ opacity: "var(--inner-bg-opacity, 1)" }}
            />

            {/* Hintergrundkontur (grauer Pfad darunter) */}
            <path
                d="M590.2,6.6l-300.3.4c-50.1,0-97.1,13.1-138,36.2h0C64.9,92.2,6,186,6,293.4
                  c0,157.9,127.3,286.3,283.7,286.4h0l767.1-1c156.5,0,283.8-128.5,283.8-286.4
                  S1213.3,6,1056.9,6l-466.8.6"
                fill="none"
                stroke="var(--outer-ring-progress)"
                strokeWidth={12}
                strokeMiterlimit={10}
                style={{ opacity: "var(--outer-ring-progress-opacity, 1)" }}
            />

            {/* Fortschrittskontur oben drauf */}
            <path
                ref={pathRef}
                d="M590.2,6.6l-300.3.4c-50.1,0-97.1,13.1-138,36.2h0C64.9,92.2,6,186,6,293.4
                  c0,157.9,127.3,286.3,283.7,286.4h0l767.1-1c156.5,0,283.8-128.5,283.8-286.4
                  S1213.3,6,1056.9,6l-466.8.6"
                fill="none"
                stroke="var(--outer-ring-bg)"
                strokeWidth={13}
                strokeMiterlimit={10}
                strokeDasharray={pathLength}
                strokeDashoffset={pathLength * progress}
                style={{
                    transition: "stroke-dashoffset 1s ease",
                    opacity: "var(--outer-ring-bg-opacity, 1)",
                }}
            />
        </svg>
    );
};

export default Background;
